/* SAM cart drawer - header sync.
   Werkt de teller en het bedrag naast het winkelwagen-icoon bij.
   Luistert naar het ajaxCart-event dat sam-cart.js na elke wijziging stuurt.
   Wijkt jullie btw-tarief af? Pas VAT_RATE hieronder aan. */
(function () {
  var VAT_RATE = 0.21;
  var cfg = window.SAMCart || {};
  var pending = null;

  function group(intStr, sep) {
    var out = "", c = 0;
    for (var i = intStr.length - 1; i >= 0; i--) {
      out = intStr.charAt(i) + out;
      c++;
      if (c % 3 === 0 && i > 0) { out = sep + out; }
    }
    return out;
  }

  function money(cents) {
    var f = cfg.money_format || "&euro;{{amount_with_comma_separator}}";
    var v = (Number(cents) / 100).toFixed(2).split(".");
    var i = v[0], d = v[1];
    var out = f;
    out = out.split("{{amount_no_decimals_with_comma_separator}}").join(group(i, "."));
    out = out.split("{{amount_with_comma_separator}}").join(group(i, ".") + "," + d);
    out = out.split("{{amount_no_decimals}}").join(group(i, ","));
    out = out.split("{{amount}}").join(group(i, ",") + "." + d);
    return out;
  }

  function apply(cart) {
    var count = cart.item_count || 0;
    var total = cart.total_price || 0;

    var c = document.getElementById("cart-count");
    if (c) { c.textContent = count; }

    var t = document.getElementById("cart-total");
    if (t) {
      var incl = t.querySelector("[data-syncer-vat-incl]");
      var excl = t.querySelector("[data-syncer-vat-excl]");
      if (incl) { incl.textContent = money(total); }
      if (excl) { excl.textContent = money(Math.round(total / (1 + VAT_RATE))); }
      if (!incl && !excl) { t.textContent = money(total); }
    }

    var links = document.querySelectorAll('a[data-panel="cart"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute("aria-label", "Winkelwagen " + money(total));
    }
  }

  function sync() {
    if (pending) { clearTimeout(pending); }
    pending = setTimeout(function () {
      var url = (cfg.routes && cfg.routes.cart_js) ? cfg.routes.cart_js : "/cart.js";
      fetch(url, { headers: { "Accept": "application/json" } })
        .then(function (r) { return r.json(); })
        .then(apply)
        .catch(function () {});
    }, 60);
  }

  document.addEventListener("ajaxCart", sync);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", sync);
  } else {
    sync();
  }
})();